import React from 'react';

// Original Streamline Ultimate Light - Free vectors, CC BY 4.0.
// https://creativecommons.org/licenses/by/4.0/
// Adaptation: beige/blue strokes to match the pricing illustrations; paths unchanged.

// https://www.streamlinehq.com/icons/download/performance-increase--32778
export const ScenarioGrowth: React.FC = () => (
    <svg aria-hidden="true" viewBox="0 0 24 24" width="48" height="48" fill="none" strokeWidth="1">
        <path
            d="m.504 23.25 23 0"
            fill="none"
            stroke="var(--scenario-icon-line, #d9cdc5)"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.5 23.25v-2.5a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v2.5"
            fill="none"
            stroke="var(--scenario-icon-line, #d9cdc5)"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.5 23.25v-6.5a.5.5 0 0 0-.5-.5H8a.5.5 0 0 0-.5.5v6.5"
            fill="none"
            stroke="var(--scenario-icon-line, #d9cdc5)"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16.5 23.25v-10.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v10.5"
            fill="none"
            stroke="var(--scenario-icon-line, #d9cdc5)"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M22.5 23.25V8.75a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v14.5"
            fill="none"
            stroke="var(--scenario-icon-line, #d9cdc5)"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="m3.004 13.25 18-12"
            fill="none"
            stroke="var(--scenario-icon-accent, #179eff)"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="m20.504 5.25.5-4-4-.5"
            fill="none"
            stroke="var(--scenario-icon-accent, #179eff)"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

// https://www.streamlinehq.com/icons/download/user-cash-scale--32778
export const ScenarioBalance: React.FC = () => (
    <svg aria-hidden="true" viewBox="0 0 24 24" width="48" height="48" fill="none" strokeWidth="1">
        <path
            d="M12.281 19.476a1 1 0 0 0-1.562 0L8.15 22.688a.5.5 0 0 0 .39.812h5.92a.5.5 0 0 0 .39-.812Z"
            fill="none"
            stroke="var(--scenario-icon-line, #d9cdc5)"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="m.5 18.5 23 0"
            fill="none"
            stroke="var(--scenario-icon-line, #d9cdc5)"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M1.25 3.25a2.75 2.75 0 1 0 5.5 0 2.75 2.75 0 1 0-5.5 0"
            fill="none"
            stroke="var(--scenario-icon-line, #d9cdc5)"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.5 10.5a3.5 3.5 0 0 0-7 0v3h1.583l.417 5h3l.417-5H7.5Z"
            fill="none"
            stroke="var(--scenario-icon-line, #d9cdc5)"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13.5 11.5a5 5 0 1 0 10 0 5 5 0 1 0-10 0"
            fill="none"
            stroke="var(--scenario-icon-accent, #179eff)"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="m18.5 13.5 0 1"
            fill="none"
            stroke="var(--scenario-icon-accent, #179eff)"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="m18.5 8.5 0 1"
            fill="none"
            stroke="var(--scenario-icon-accent, #179eff)"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16.5 13.5h3a1 1 0 0 0 0-2h-2a1 1 0 0 1 0-2h3"
            fill="none"
            stroke="var(--scenario-icon-accent, #179eff)"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

// https://www.streamlinehq.com/icons/download/shield-check-1--32776
export const ScenarioShield: React.FC = () => (
    <svg aria-hidden="true" viewBox="0 0 24 24" width="48" height="48" fill="none" strokeWidth="1">
        <path
            d="M17 10.5a5 5 0 1 1-5-5"
            fill="none"
            stroke="var(--scenario-icon-accent, #179eff)"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="m10 10 1.62 1.215a.5.5 0 0 0 .684-.08L17 5.5"
            fill="none"
            stroke="var(--scenario-icon-accent, #179eff)"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M1.5 3.775v7.637A12.311 12.311 0 0 0 9.719 22.88l1.121.414a3.365 3.365 0 0 0 2.32 0l1.121-.414A12.311 12.311 0 0 0 22.5 11.412V3.775a1.533 1.533 0 0 0-.934-1.406A24.237 24.237 0 0 0 12 .5a24.237 24.237 0 0 0-9.566 1.869A1.533 1.533 0 0 0 1.5 3.775"
            fill="none"
            stroke="var(--scenario-icon-line, #d9cdc5)"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

// https://www.streamlinehq.com/icons/download/settings-slider-desktop-horizontal--32804
export const ScenarioSettings: React.FC = () => (
    <svg aria-hidden="true" viewBox="0 0 24 24" width="48" height="48" fill="none" strokeWidth="1">
        <path
            d="M6.5 6.501a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"
            fill="none"
            stroke="var(--scenario-icon-accent, #179eff)"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.5 11.501a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"
            fill="none"
            stroke="var(--scenario-icon-accent, #179eff)"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="m4.5 6.501 2 0"
            fill="none"
            stroke="var(--scenario-icon-accent, #179eff)"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="m9.5 6.501 10 0"
            fill="none"
            stroke="var(--scenario-icon-accent, #179eff)"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9.138 23.5a7.486 7.486 0 0 0 1.362-4"
            fill="none"
            stroke="var(--scenario-icon-line, #d9cdc5)"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.862 23.5a7.486 7.486 0 0 1-1.362-4"
            fill="none"
            stroke="var(--scenario-icon-line, #d9cdc5)"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="m7.5 23.501 9 0"
            fill="none"
            stroke="var(--scenario-icon-line, #d9cdc5)"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="m.5 16.501 23 0"
            fill="none"
            stroke="var(--scenario-icon-line, #d9cdc5)"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M1.5.501h21s1 0 1 1v17s0 1-1 1h-21s-1 0-1-1v-17s0-1 1-1"
            fill="none"
            stroke="var(--scenario-icon-line, #d9cdc5)"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="m14.5 11.501-10 0"
            fill="none"
            stroke="var(--scenario-icon-accent, #179eff)"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="m17.5 11.501 2 0"
            fill="none"
            stroke="var(--scenario-icon-accent, #179eff)"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const scenarioIllustrations: Record<string, React.FC> = {
    optimistic: ScenarioGrowth,
    neutral: ScenarioBalance,
    pessimistic: ScenarioShield,
    custom: ScenarioSettings,
};
